const pl = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Ładowanie...',
    error: 'Błąd',
    save: 'Zapisz',
    cancel: 'Anuluj',
    delete: 'Usuń',
    edit: 'Edytuj',
    create: 'Utwórz',
    add: 'Dodaj',
    remove: 'Usuń',
    close: 'Zamknij',
    confirm: 'Potwierdź',
    apply: 'Zastosuj',
    reset: 'Resetuj',
    search: 'Szukaj',
    filter: 'Filtruj',
    clear: 'Wyczyść',
    back: 'Wstecz',
    next: 'Dalej',
    previous: 'Poprzedni',
    submit: 'Wyślij',
    update: 'Aktualizuj',
    refresh: 'Odśwież',
    export: 'Eksportuj',
    import: 'Importuj',
    download: 'Pobierz',
    upload: 'Prześlij',
    print: 'Drukuj',
    copy: 'Kopiuj',
    yes: 'Tak',
    no: 'Nie',
    ok: 'OK',
    done: 'Gotowe',
    select: 'Wybierz',
    selectAll: 'Zaznacz wszystko',
    deselectAll: 'Odznacz wszystko',
    noResults: 'Nie znaleziono wyników',
    noData: 'Brak dostępnych danych',
    required: 'Wymagane',
    optional: 'Opcjonalne',
    actions: 'Akcje',
    details: 'Szczegóły',
    overview: 'Przegląd',
    summary: 'Podsumowanie',
    total: 'Razem',
    all: 'Wszystko',
    none: 'Brak',
    name: 'Nazwa',
    type: 'Typ',
    status: 'Status',
    date: 'Data',
    time: 'Czas',
    description: 'Opis',
    notes: 'Notatki',
    comments: 'Komentarze',
    category: 'Kategoria',
    priority: 'Priorytet',
    nation: 'Państwo',
    country: 'Kraj',
    email: 'E-mail',
    phone: 'Telefon',
    address: 'Adres',
    location: 'Lokalizacja',
    coordinates: 'Współrzędne',
    latitude: 'Szerokość geograficzna',
    longitude: 'Długość geograficzna',
    from: 'Od',
    to: 'Do',
    createdAt: 'Utworzono',
    updatedAt: 'Zaktualizowano',
    createdBy: 'Utworzono przez',
    modifiedBy: 'Zmodyfikowano przez',
    active: 'Aktywne',
    inactive: 'Nieaktywne',
    enabled: 'Włączone',
    disabled: 'Wyłączone',
    showing: 'Wyświetlanie',
    of: 'z',
    page: 'Strona',
    perPage: 'na stronę',
    rows: 'wierszy',
    items: 'elementów',
    results: 'wyników',
    sortBy: 'Sortuj wg',
    ascending: 'Rosnąco',
    descending: 'Malejąco',
    viewAll: 'Pokaż wszystko',
    viewDetails: 'Pokaż szczegóły',
    goBack: 'Wróć',
    learnMore: 'Dowiedz się więcej',
    seeMore: 'Zobacz więcej',
    showMore: 'Pokaż więcej',
    showLess: 'Pokaż mniej',
    expandAll: 'Rozwiń wszystko',
    collapseAll: 'Zwiń wszystko',
    copied: 'Skopiowano!',
    saved: 'Zapisano!',
    deleted: 'Usunięto!',
    updated: 'Zaktualizowano!',
    created: 'Utworzono!',
    success: 'Sukces',
    warning: 'Ostrzeżenie',
    info: 'Informacja',
    danger: 'Niebezpieczeństwo',
    unknown: 'Nieznane',
    notAvailable: 'Nie dotyczy',
    never: 'Nigdy',
    today: 'Dzisiaj',
    yesterday: 'Wczoraj',
    tomorrow: 'Jutro',
    now: 'Teraz',
    ago: 'temu',
    justNow: 'przed chwilą',
    minutesAgo: '{{count}}min temu',
    hoursAgo: '{{count}}godz. temu',
    daysAgo: '{{count}}d temu',
    monthsAgo: '{{count}}mies. temu',
    id: 'Identyfikator',
    version: 'Wersja',
    language: 'Język',
    theme: 'Motyw',
    darkMode: 'Tryb ciemny',
    lightMode: 'Tryb jasny',
    failedToLoad: 'Nie udało się załadować danych',
    failedToSave: 'Nie udało się zapisać',
    failedToDelete: 'Nie udało się usunąć',
    failedToUpdate: 'Nie udało się zaktualizować',
    confirmDelete: 'Czy na pewno chcesz to usunąć?',
    confirmAction: 'Czy na pewno?',
    unsavedChanges: 'Masz niezapisane zmiany. Czy na pewno chcesz wyjść?',
    pageNotFound: '404 - Strona nie znaleziona',
    pageNotFoundDesc: 'Strona, której szukasz, nie istnieje.',
    backToDashboard: 'Powrót do pulpitu',
    characters: 'znaków',
    maxCharacters: 'Maksymalnie {{max}} znaków',
    remaining: '{{count}} pozostało',
    selected: '{{count}} zaznaczono',
    of_total: '{{count}} z {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Pulpit',
    requests: 'Wnioski',
    transports: 'Transporty',
    myPatients: 'Moi pacjenci',
    statistics: 'Statystyki',
    flow: 'Przepływ',
    resources: 'Resources',
    exercise: 'Ćwiczenie',
    administration: 'Administracja',
    map: 'Mapa',
    info: 'Informacje',
    users: 'Użytkownicy',
    assets: 'Zasoby',
    hubs: 'Węzły',
    treatmentFacilities: 'Placówki lecznicze',
    patientImport: 'Import pacjentów',
    assetTemplates: 'Szablony zasobów',
    dayTemplates: 'Szablony dnia',
    announcementTicker: 'Pasek ogłoszeń',
    exerciseStatistics: 'Statystyki ćwiczenia',
    settings: 'Ustawienia',
    auditLog: 'Dziennik audytu',
    exerciseControl: 'Kontrola ćwiczenia',
    dataSync: 'Synchronizacja danych',
    documentation: 'Dokumentacja',
    support: 'Wsparcie',
    about: 'O systemie',
    assetContracts: 'Asset Contracts',
    notifications: 'Powiadomienia',
    schedules: 'Harmonogramy',
    capacityPlanning: 'Planowanie pojemności',
    transportPlanning: 'Planowanie transportu',
    transportBooking: 'Rezerwacja transportu',
    flowDiagram: 'Diagram przepływu',
    changePassword: 'Zmień hasło',
    missions: 'Misje',
    startPoints: 'Punkty startowe',
    hospital: 'Szpital',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Logowanie',
    logout: 'Wylogowanie',
    logoutNow: 'Wyloguj teraz',
    loggingIn: 'Logowanie...',
    loginFailed: 'Logowanie nie powiodło się',
    email: 'E-mail',
    password: 'Hasło',
    username: 'Nazwa użytkownika',
    enterEmail: 'Wprowadź adres e-mail',
    enterPassword: 'Wprowadź hasło',
    enterUsername: 'Wprowadź nazwę użytkownika',
    forgotPassword: 'Zapomniałeś hasła?',
    forgotPasswordTitle: 'Zapomniałem hasła',
    forgotPasswordDesc: 'Wprowadź nazwę użytkownika i adres e-mail. Jeśli oba się zgadzają, administratorzy zostaną powiadomieni o konieczności zresetowania hasła.',
    requestPasswordReset: 'Żądanie zresetowania hasła',
    sending: 'Wysyłanie...',
    backToLogin: 'Powrót do logowania',
    pleaseWait: 'Proszę poczekać przed ponowną próbą.',
    requestFailed: 'Żądanie nie powiodło się',
    credentialsMatch: 'Jeśli dane logowania są prawidłowe, administratorzy zostali powiadomieni.',
    forAccess: 'Aby uzyskać dostęp, skontaktuj się z administratorem systemu.',
    changePassword: 'Zmień hasło',
    currentPassword: 'Obecne hasło',
    newPassword: 'Nowe hasło',
    confirmPassword: 'Potwierdź hasło',
    passwordChanged: 'Hasło zostało zmienione pomyślnie',
    passwordMismatch: 'Hasła nie są zgodne',
    passwordTooShort: 'Hasło musi mieć co najmniej 8 znaków',
    changingPassword: 'Zmieniam...',
    mustChangePassword: 'Musisz zmienić hasło, zanim będziesz mógł kontynuować.',
    sessionExpiring: 'Sesja wygasa',
    sessionExpireText: 'Twoja sesja wygaśnie za <strong>{{time}}</strong>. Proszę zapisać swoją pracę i zalogować się ponownie, aby kontynuować.',
    dismiss: 'Odrzuć',
    switchNation: 'Zmień państwo',
    returnTo: 'Powrót do {{nation}}',
    viewingAs: 'Przeglądasz jako',
    loggedInAs: 'zalogowany jako {{nation}}',
    trainingMode: 'WYŁĄCZNIE DO CELÓW SZKOLENIOWYCH',
    dedication: 'Stworzone z miłością i oddaniem dla zawodu',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Administrator systemu',
    excon: 'Kontroler ćwiczenia',
    eu: 'Koordynator UE',
    planner: 'Planista',
    hub: 'Kierownik węzła',
    nation: 'Państwo',
    readOnly: 'Tylko do odczytu',
    systemAdmin: 'Administrator systemu',
    transportPlanner: 'Planista transportu',
    systemRoles: 'Role systemowe',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Szkic',
    underReview: 'W przeglądzie',
    published: 'Opublikowane',
    underSelection: 'W selekcji',
    accepted: 'Zaakceptowane',
    planned: 'Zaplanowane',
    inTransit: 'W transporcie',
    completed: 'Zakończone',
    closed: 'Zamknięte',
    withdrawn: 'Wycofane',
    pending: 'Oczekujące',
    rejected: 'Odrzucone',
    cancelled: 'Anulowane',
    active: 'Aktywne',
    inactive: 'Nieaktywne',
    review: 'Przegląd',
    selection: 'Selekcja',
    transit: 'Tranzyt',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personel',
    material: 'Materiał',
    equipment: 'Wyposażenie',
    other: 'Inne',
    news: 'Aktualności',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Rutynowe',
    priority: 'Priorytetowe',
    urgent: 'Pilne',
    immediate: 'Natychmiastowe',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Pociąg',
    ship: 'Statek',
    aircraft: 'Samolot',
    bus: 'Autobus',
    ambulance: 'Karetka',
    drone: 'Dron',
    helicopter: 'Śmigłowiec',
    ferry: 'Prom',
    other: 'Inne',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Pulpit',
    goodMorning: 'Dzień dobry',
    goodAfternoon: 'Dzień dobry',
    goodEvening: 'Dobry wieczór',
    lastLogin: 'Ostatnie logowanie',
    infrastructure: 'Infrastruktura',
    transportAssets: 'Zasoby transportowe',
    treatmentFacilities: 'Placówki lecznicze',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Statystyki wniosków',
    viewAllRequests: 'Pokaż wszystkie wnioski',
    availableAssets: 'Dostępne zasoby',
    seated: 'Siedzący',
    lying: 'Leżący',
    intensive: 'Intensywna opieka',
    notifications: 'Powiadomienia',
    markAllRead: 'Oznacz wszystko jako przeczytane',
    noNotifications: 'Brak powiadomień',
    notifiedWhenActivity: 'Zostaniesz powiadomiony, gdy pojawi się nowa aktywność',
    viewDetailsBtn: 'Pokaż szczegóły',
    nationUsers: 'Użytkownicy państwa',
    user: 'Użytkownik',
    roles: 'Role',
    noUsersFound: 'Nie znaleziono użytkowników',
    participatingNations: 'Uczestniczące państwa',
    exerciseDisclaimer: 'Ten system służy wyłącznie do celów ćwiczebnych. Wprowadzaj wyłącznie symulowane dane ćwiczenia. Procesy robocze są dostosowane do scenariusza ćwiczenia i mogą różnić się od procedur rzeczywistych. Zasady bezpieczeństwa IT i ochrony danych obowiązują w pełni.',
    notConfigured: 'Nieskonfigurowane',
    requestCount: '{{count}} wniosek(ów)',
    clickToView: 'Kliknij, aby wyświetlić',
    systemAdministration: 'Administracja systemem',
    exerciseControlTitle: 'Kontrola ćwiczenia',
    euCoordination: 'Koordynacja UE',
    transportPlanningTitle: 'Planowanie transportu',
    hubManagement: 'Zarządzanie węzłami',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nowy wniosek',
    myDrafts: 'Moje szkice',
    pendingReview: 'Oczekujące na przegląd',
    activeTransports: 'Aktywne transporty',
    myPatients: 'Moi pacjenci',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Wnioski',
    newRequest: 'Nowy wniosek',
    createRequest: 'Utwórz wniosek',
    editRequest: 'Edytuj wniosek',
    requestDetail: 'Szczegóły wniosku',
    requestId: 'Identyfikator wniosku',
    fromNation: 'Od państwa',
    toNation: 'Do państwa',
    requestingNation: 'Państwo wnioskujące',
    receivingNation: 'Państwo przyjmujące',
    category: 'Kategoria',
    urgency: 'Pilność',
    status: 'Status',
    patients: 'Pacjenci',
    patientCount: 'Liczba pacjentów',
    offers: 'Oferty',
    offerCount: 'Liczba ofert',
    created: 'Utworzono',
    updated: 'Zaktualizowano',
    submittedBy: 'Przesłano przez',
    reviewedBy: 'Zrecenzowano przez',
    description: 'Opis',
    medicalDetails: 'Szczegóły medyczne',
    transportDetails: 'Szczegóły transportu',
    additionalInfo: 'Dodatkowe informacje',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Punkt odjazdu',
    arrivalPoint: 'Punkt przyjazdu',
    estimatedDeparture: 'Szacowany odjazd',
    estimatedArrival: 'Szacowany przyjazd',
    submitForReview: 'Wyślij do przeglądu',
    publish: 'Opublikuj',
    startSelection: 'Rozpocznij selekcję',
    acceptOffer: 'Zaakceptuj ofertę',
    markInTransit: 'Oznacz jako w transporcie',
    markCompleted: 'Oznacz jako zakończone',
    closeRequest: 'Zamknij wniosek',
    withdrawRequest: 'Wycofaj wniosek',
    withdraw: 'Wycofaj',
    revertToDraft: 'Przywróć do szkicu',
    deleteRequest: 'Usuń wniosek',
    duplicateRequest: 'Duplikuj wniosek',
    createFollowUp: 'Utwórz wniosek skonsolidowany',
    followUpRequest: 'Wniosek skonsolidowany',
    parentRequest: 'Wniosek pierwotny',
    childRequests: 'Wnioski skonsolidowane',
    noRequests: 'Nie znaleziono wniosków',
    noOffers: 'Brak ofert',
    addPatient: 'Dodaj pacjenta',
    removePatient: 'Usuń pacjenta',
    patientDetails: 'Dane pacjenta',
    contactPerson: 'Osoba kontaktowa',
    contactPhone: 'Telefon kontaktowy',
    contactEmail: 'E-mail kontaktowy',
    specialRequirements: 'Wymagania specjalne',
    medicalEquipment: 'Sprzęt medyczny',
    accompaniment: 'Towarzyszenie',
    timeline: 'Oś czasu',
    history: 'Historia',
    addComment: 'Dodaj komentarz',
    writeComment: 'Napisz komentarz...',
    postComment: 'Opublikuj komentarz',
    posting: 'Publikowanie...',
    noComments: 'Brak komentarzy',
    coverageBar: 'Pokrycie',
    covered: 'pokryte',
    uncovered: 'niepokryte',
    filterByStatus: 'Filtruj wg statusu',
    filterByCategory: 'Filtruj wg kategorii',
    filterByNation: 'Filtruj wg państwa',
    searchRequests: 'Szukaj wniosków...',
    confirmWithdraw: 'Czy na pewno chcesz wycofać ten wniosek?',
    confirmDelete: 'Czy na pewno chcesz usunąć ten wniosek?',
    confirmPublish: 'Czy na pewno chcesz opublikować ten wniosek? Będzie widoczny dla wszystkich państw.',
    confirmStartSelection: 'Czy na pewno chcesz rozpocząć selekcję? Państwa będą mogły składać oferty.',
    warningStartSelection: 'Rozpoczęcie selekcji sprawi, że ten wniosek będzie widoczny dla wszystkich uczestniczących państw. Będą mogły składać oferty dotyczące pacjentów w tym wniosku. Tej operacji nie można cofnąć.',
    warningMakeOffer: 'Składając tę ofertę, zobowiązujesz swoje państwo do zapewnienia proponowanej pomocy. Ta operacja powiadomi państwo wnioskujące i kontrolę ćwiczenia.',
    saveDraft: 'Zapisz szkic',
    saving: 'Zapisywanie...',
    saveAndSubmit: 'Zapisz i wyślij',
    step: 'Krok {{number}}',
    generalInfo: 'Informacje ogólne',
    patientInfo: 'Informacje o pacjencie',
    logisticsInfo: 'Informacje logistyczne',
    reviewSubmit: 'Przegląd i wysłanie',
    requestTitle: 'Tytuł wniosku',
    requestDescription: 'Opis wniosku',
    numberOfPatients: 'Liczba pacjentów',
    typeOfAssistance: 'Rodzaj pomocy',
    medicalTreatment: 'Leczenie',
    transportAssistance: 'Pomoc transportowa',
    both: 'Obydwa',
    treatmentOnly: 'Tylko leczenie',
    transportOnly: 'Tylko transport',
    validationErrors: 'Proszę poprawić następujące błędy:',
    fieldRequired: 'To pole jest wymagane',
    selectExitHub: 'Wybierz węzeł wyjściowy',
    createExitHub: 'Utwórz węzeł wyjściowy',
    backToRequests: 'Powrót do wniosków',
    noRequestsFound: 'Nie znaleziono wniosków',
    createFirstRequest: 'Utwórz swój pierwszy wniosek, aby rozpocząć',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Oferty',
    createOffer: 'Utwórz ofertę',
    makeOffer: 'Złóż ofertę',
    manageOffers: 'Zarządzaj ofertami',
    offerDetail: 'Szczegóły oferty',
    offerId: 'Identyfikator oferty',
    offeringNation: 'Państwo oferujące',
    offerType: 'Typ oferty',
    treatment: 'Leczenie',
    transport: 'Transport',
    combined: 'Łączona',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Oferta leczenia',
    transportOffer: 'Oferta transportu',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Wybierz pacjentów',
    selectedPatients: 'Wybrani pacjenci',
    patientSelection: 'Wybór pacjentów',
    offerConfiguration: 'Konfiguracja oferty',
    reviewOffer: 'Przegląd oferty',
    submitOffer: 'Złóż ofertę',
    submitting: 'Wysyłanie...',
    acceptOffer: 'Zaakceptuj ofertę',
    rejectOffer: 'Odrzuć ofertę',
    withdrawOffer: 'Wycofaj ofertę',
    noOffers: 'Brak dostępnych ofert',
    noOffer: 'No Offer',
    offerStatus: 'Status oferty',
    offerDate: 'Data oferty',
    transportAsset: 'Zasób transportowy',
    departureDate: 'Data odjazdu',
    arrivalDate: 'Data przyjazdu',
    treatmentFacility: 'Placówka lecznicza',
    capacity: 'Pojemność',
    availableCapacity: 'Dostępna pojemność',
    totalCapacity: 'Całkowita pojemność',
    selectAsset: 'Wybierz zasób',
    selectFacility: 'Wybierz placówkę',
    offerNotes: 'Uwagi do oferty',
    confirmAccept: 'Czy na pewno chcesz zaakceptować tę ofertę?',
    confirmReject: 'Czy na pewno chcesz odrzucić tę ofertę?',
    extendTransport: 'Rozszerz transport',
    transportExtension: 'Rozszerzenie transportu',
    comparisonView: 'Widok porównawczy',
    shortlist: 'Lista skrócona',
    addToShortlist: 'Dodaj do listy skróconej',
    removeFromShortlist: 'Usuń z listy skróconej',
    leaveConfirmTitle: 'Opuścić tę stronę?',
    leaveConfirmMessage: 'Masz niezapisane zmiany. Czy na pewno chcesz wyjść?',
    stayOnPage: 'Pozostań na stronie',
    leavePage: 'Opuść stronę',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporty',
    missionDetail: 'Szczegóły transportu',
    missionId: 'Identyfikator transportu',
    missionStatus: 'Status transportu',
    createMission: 'Utwórz transport',
    overview: 'Przegląd',
    patientsTab: 'Pacjenci',
    transportsTab: 'Odcinki transportu',
    treatmentTab: 'Leczenie',
    reviewTab: 'Przegląd',
    departure: 'Odjazd',
    arrival: 'Przyjazd',
    origin: 'Pochodzenie',
    destination: 'Cel',
    stops: 'Przystanki',
    addStop: 'Dodaj przystanek',
    removeStop: 'Usuń przystanek',
    stopName: 'Nazwa przystanku',
    stopType: 'Typ przystanku',
    estimatedTime: 'Szacowany czas',
    actualTime: 'Rzeczywisty czas',
    asset: 'Zasób',
    driver: 'Kierowca',
    crew: 'Załoga',
    noMissions: 'Nie znaleziono transportów',
    completeMission: 'Zakończ transport',
    cancelMission: 'Anuluj transport',
    startTransport: 'Rozpocznij transport',
    missionChain: 'Łańcuch transportowy',
    linkedMissions: 'Powiązane transporty',
    handover: 'Przekazanie',
    handoverPoint: 'Punkt przekazania',
    pickupPoint: 'Punkt odbioru',
    dropoffPoint: 'Punkt docelowy',
    searchTransports: 'Szukaj transportów...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacjenci',
    myPatients: 'Moi pacjenci',
    patientId: 'Identyfikator pacjenta',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    dateOfBirth: 'Data urodzenia',
    age: 'Wiek',
    gender: 'Płeć',
    male: 'Mężczyzna',
    female: 'Kobieta',
    other: 'Inna',
    nationality: 'Narodowość',
    diagnosis: 'Diagnoza',
    condition: 'Stan',
    stable: 'Stabilny',
    critical: 'Krytyczny',
    serious: 'Poważny',
    treatmentNeeded: 'Wymagane leczenie',
    allergies: 'Alergie',
    medications: 'Leki',
    bloodType: 'Grupa krwi',
    weight: 'Waga (kg)',
    infectious: 'Zakaźny',
    mentalHealth: 'Zdrowie psychiczne',
    mobility: 'Mobilność',
    ambulatory: 'Chodzący',
    wheelchair: 'Wózek inwalidzki',
    stretcher: 'Nosze',
    intensive: 'Opieka intensywna',
    oxygenRequired: 'Wymagany tlen',
    ventilator: 'Respirator',
    medicalEscort: 'Eskorta medyczna',
    noPatients: 'Nie znaleziono pacjentów',
    patientDetails: 'Dane pacjenta',
    medicalHistory: 'Historia medyczna',
    travelDocuments: 'Dokumenty podróżne',
    passport: 'Paszport',
    pseudonymizedId: 'Identyfikator pseudonimowy',
    sensitiveData: 'Dane wrażliwe',
    journey: 'Podróż pacjenta',
    assignedTo: 'Przypisano do',
    currentLocation: 'Bieżąca lokalizacja',
    importPatients: 'Importuj pacjentów',
    exportPatients: 'Eksportuj pacjentów',
    seated: 'Siedzący',
    lying: 'Leżący',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Użytkownicy',
    createUser: 'Utwórz użytkownika',
    editUser: 'Edytuj użytkownika',
    deleteUser: 'Usuń użytkownika',
    username: 'Nazwa użytkownika',
    displayName: 'Nazwa wyświetlana',
    email: 'E-mail',
    password: 'Hasło',
    role: 'Rola',
    roles: 'Role',
    nation: 'Państwo',
    active: 'Aktywny',
    lastLogin: 'Ostatnie logowanie',
    createdAt: 'Utworzono',
    isNation: 'Państwo',
    isEU: 'UE',
    isAdmin: 'Administrator',
    isExcon: 'EXCON',
    isPlanner: 'Planista',
    isHub: 'Węzeł',
    isReadOnly: 'Tylko do odczytu',
    noUsers: 'Nie znaleziono użytkowników',
    confirmDelete: 'Czy na pewno chcesz usunąć tego użytkownika?',
    resetPassword: 'Zresetuj hasło',
    generatePassword: 'Wygeneruj hasło',
    searchUsers: 'Szukaj użytkowników...',
    userCreated: 'Użytkownik został utworzony pomyślnie',
    userUpdated: 'Użytkownik został zaktualizowany pomyślnie',
    userDeleted: 'Użytkownik został usunięty pomyślnie',
    selectNation: 'Wybierz państwo',
    mustChangePassword: 'Musi zmienić hasło przy następnym logowaniu',
    flagImage: 'Obraz flagi',
    exportUsers: 'Eksportuj użytkowników',
    importUsers: 'Importuj użytkowników',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Zasoby',
    createAsset: 'Utwórz zasób',
    editAsset: 'Edytuj zasób',
    deleteAsset: 'Usuń zasób',
    assetName: 'Nazwa zasobu',
    assetType: 'Typ zasobu',
    capacitySeated: 'Pojemność (siedzący)',
    capacityLying: 'Pojemność (leżący)',
    capacityIntensive: 'Pojemność (intensywna opieka)',
    owner: 'Właściciel',
    operator: 'Operator',
    baseLocation: 'Lokalizacja bazowa',
    range: 'Zasięg',
    speed: 'Prędkość',
    noAssets: 'Nie znaleziono zasobów',
    confirmDelete: 'Czy na pewno chcesz usunąć ten zasób?',
    searchAssets: 'Szukaj zasobów...',
    assetCreated: 'Zasób został utworzony pomyślnie',
    assetUpdated: 'Zasób został zaktualizowany pomyślnie',
    assetDeleted: 'Zasób został usunięty pomyślnie',
    exportAssets: 'Eksportuj zasoby',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Węzły',
    startPoints: 'Punkty startowe',
    createHub: 'Utwórz węzeł',
    editHub: 'Edytuj węzeł',
    deleteHub: 'Usuń węzeł',
    hubName: 'Nazwa węzła',
    hubType: 'Typ węzła',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Węzeł wejściowy',
    airport: 'Lotnisko',
    seaport: 'Port morski',
    railStation: 'Stacja kolejowa',
    roadPoint: 'Punkt drogowy',
    ucpmClassification: 'Klasyfikacja UCPM',
    icaoCode: 'Kod ICAO',
    iataCode: 'Kod IATA',
    noHubs: 'Nie znaleziono węzłów',
    confirmDelete: 'Czy na pewno chcesz usunąć ten węzeł?',
    searchHubs: 'Szukaj węzłów...',
    nationAssignment: 'Przypisanie państw',
    assignNations: 'Przypisz państwa',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Placówki lecznicze',
    createFacility: 'Utwórz placówkę',
    editFacility: 'Edytuj placówkę',
    deleteFacility: 'Usuń placówkę',
    facilityName: 'Nazwa placówki',
    facilityType: 'Typ placówki',
    hospitalName: 'Nazwa szpitala',
    bedCapacity: 'Pojemność łóżek',
    specialties: 'Specjalizacje',
    availableBeds: 'Dostępne łóżka',
    totalBeds: 'Łóżka ogółem',
    contactPerson: 'Osoba kontaktowa',
    noFacilities: 'Nie znaleziono placówek leczniczych',
    confirmDelete: 'Czy na pewno chcesz usunąć tę placówkę?',
    searchFacilities: 'Szukaj placówek...',
    hubNationAssignment: 'Przypisanie węzłów do państw',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Harmonogramy',
    createSchedule: 'Utwórz harmonogram',
    editSchedule: 'Edytuj harmonogram',
    deleteSchedule: 'Usuń harmonogram',
    scheduleName: 'Nazwa harmonogramu',
    scheduleType: 'Typ harmonogramu',
    recurring: 'Cykliczny',
    oneTime: 'Jednorazowy',
    frequency: 'Częstotliwość',
    daily: 'Dzienny',
    weekly: 'Tygodniowy',
    startDate: 'Data rozpoczęcia',
    endDate: 'Data zakończenia',
    departureTime: 'Czas odjazdu',
    arrivalTime: 'Czas przyjazdu',
    stops: 'Przystanki',
    addStop: 'Dodaj przystanek',
    noSchedules: 'Nie znaleziono harmonogramów',
    bookings: 'Rezerwacje',
    timeline: 'Oś czasu',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Powiadomienia',
    markAllRead: 'Oznacz wszystko jako przeczytane',
    markAsRead: 'Oznacz jako przeczytane',
    markAsUnread: 'Oznacz jako nieprzeczytane',
    noNotifications: 'Brak powiadomień',
    viewAll: 'Pokaż wszystkie powiadomienia',
    settings: 'Ustawienia powiadomień',
    emailNotifications: 'Powiadomienia e-mail',
    inAppNotifications: 'Powiadomienia w aplikacji',
    notifyOn: 'Powiadamiaj o',
    requestCreated: 'Nowy wniosek',
    requestPublished: 'Wniosek opublikowany',
    requestClosed: 'Wniosek zamknięty',
    requestCompleted: 'Wniosek zakończony',
    commentAdded: 'Nowy komentarz',
    offerReceived: 'Oferta otrzymana',
    offerAccepted: 'Oferta zaakceptowana',
    statusChanged: 'Zmiana statusu',
    selectionStarted: 'Selekcja rozpoczęta',
    missionCreated: 'Transport utworzony',
    missionStatusUpdated: 'Transport zaktualizowany',
    transportPartnerNamed: 'Partner transportowy',
    transportExtensionReceived: 'Rozszerzenie transportu',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Ustawienia',
    general: 'Ogólne',
    system: 'System',
    email: 'E-mail',
    sync: 'Synchronizacja',
    security: 'Bezpieczeństwo',
    appearance: 'Wygląd',
    systemName: 'Nazwa systemu',
    systemEmail: 'E-mail systemowy',
    maintenanceMode: 'Tryb konserwacji',
    readOnlyMode: 'Tryb tylko do odczytu',
    emailEnabled: 'E-mail włączony',
    smtpHost: 'Serwer SMTP',
    smtpPort: 'Port SMTP',
    smtpUser: 'Użytkownik SMTP',
    smtpPassword: 'Hasło SMTP',
    senderEmail: 'E-mail nadawcy',
    senderName: 'Nazwa nadawcy',
    testEmail: 'Wyślij e-mail testowy',
    syncEnabled: 'Synchronizacja włączona',
    syncUrl: 'Adres URL synchronizacji',
    syncApiKey: 'Klucz API synchronizacji',
    settingsSaved: 'Ustawienia zostały zapisane pomyślnie',
    helpdesk: 'Pomoc techniczna',
    helpdeskTitle: 'Tytuł pomocy technicznej',
    helpdeskEmail: 'E-mail pomocy technicznej',
    helpdeskPhone: 'Telefon pomocy technicznej',
    helpdeskInfo: 'Informacje pomocy technicznej',
    realLifeSupport: 'Wsparcie w sytuacjach rzeczywistych',
    trainingMode: 'Tryb szkoleniowy',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Dzienniki audytu',
    action: 'Akcja',
    user: 'Użytkownik',
    target: 'Cel',
    details: 'Szczegóły',
    timestamp: 'Znacznik czasu',
    ipAddress: 'Adres IP',
    noLogs: 'Nie znaleziono dzienników audytu',
    searchLogs: 'Szukaj w dziennikach...',
    filterByAction: 'Filtruj wg akcji',
    filterByUser: 'Filtruj wg użytkownika',
    exportLogs: 'Eksportuj dzienniki',
    exportCsv: 'Eksportuj CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Kontrola ćwiczenia',
    currentDay: 'Bieżący dzień',
    exerciseDay: 'Dzień ćwiczenia',
    nextDay: 'Następny dzień',
    previousDay: 'Poprzedni dzień',
    resetExercise: 'Zresetuj ćwiczenie',
    startExercise: 'Rozpocznij ćwiczenie',
    endExercise: 'Zakończ ćwiczenie',
    dayReset: 'Reset dnia',
    confirmReset: 'Czy na pewno chcesz zresetować dzień ćwiczenia? Spowoduje to usunięcie wszystkich danych z bieżącego dnia.',
    resetInProgress: 'Resetowanie w toku...',
    maintenanceMode: 'Tryb konserwacji',
    enableMaintenance: 'Włącz konserwację',
    disableMaintenance: 'Wyłącz konserwację',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Synchronizacja danych',
    syncStatus: 'Status synchronizacji',
    lastSync: 'Ostatnia synchronizacja',
    pendingItems: 'Elementy oczekujące',
    syncNow: 'Synchronizuj teraz',
    syncing: 'Synchronizowanie...',
    syncSuccess: 'Synchronizacja zakończona pomyślnie',
    syncFailed: 'Synchronizacja nie powiodła się',
    outbox: 'Skrzynka nadawcza',
    inbox: 'Skrzynka odbiorcza',
    configuration: 'Konfiguracja',
    targetUrl: 'Docelowy adres URL',
    apiKey: 'Klucz API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Mapa',
    layers: 'Warstwy',
    requests: 'Wnioski',
    hubs: 'Węzły',
    facilities: 'Placówki',
    routes: 'Trasy',
    showAll: 'Pokaż wszystko',
    hideAll: 'Ukryj wszystko',
    zoomIn: 'Powiększ',
    zoomOut: 'Pomniejsz',
    resetView: 'Resetuj widok',
    satellite: 'Satelitarna',
    terrain: 'Terenowa',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Kafelki mapy są udostępniane lokalnie',
    tilesOnline: 'Kafelki mapy są pobierane z serwerów internetowych',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statystyki',
    overview: 'Przegląd',
    requestsByStatus: 'Wnioski wg statusu',
    requestsByCategory: 'Wnioski wg kategorii',
    requestsByNation: 'Wnioski wg państwa',
    offersByStatus: 'Oferty wg statusu',
    patientsByCondition: 'Pacjenci wg stanu',
    transportsByStatus: 'Transporty wg statusu',
    timeline: 'Oś czasu',
    totalRequests: 'Wnioski ogółem',
    totalOffers: 'Oferty ogółem',
    totalPatients: 'Pacjenci ogółem',
    totalTransports: 'Transporty ogółem',
    averageResponseTime: 'Średni czas odpowiedzi',
    completionRate: 'Wskaźnik ukończenia',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Statystyki ćwiczenia',
    overview: 'Przegląd',
    byCategory: 'Wg kategorii',
    byNation: 'Wg państwa',
    byDay: 'Wg dnia',
    totalPatientsMoved: 'Łączna liczba przetransportowanych pacjentów',
    totalRequestsProcessed: 'Łączna liczba przetworzonych wniosków',
    averageProcessingTime: 'Średni czas przetwarzania',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagram przepływu',
    sankey: 'Sankey',
    nodeGraph: 'Graf węzłów',
    refresh: 'Odśwież',
    noData: 'Brak dostępnych danych przepływu',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'O systemie',
    version: 'Wersja',
    systemInfo: 'Informacje o systemie',
    buildDate: 'Data kompilacji',
    environment: 'Środowisko',
    description: 'ARCOS — Zaawansowany System Komunikacji Wniosków',
    subtitle: 'Pomoc ofiarom i operacje medyczne',
    whatIsArcos: 'Czym jest ARCOS? – Wyjaśnienie dla uczestników ćwiczenia',
    arcosDesc1: 'ARCOS to narzędzie cyfrowe używane w tym ćwiczeniu do wspierania i strukturyzowania międzynarodowej komunikacji, wniosków i procesów koordynacyjnych między uczestniczącymi aktorami.',
    arcosDesc2: 'ARCOS zapewnia uproszczoną, zorientowaną na ćwiczenie reprezentację podstawowych zasad tych systemów.',
    arcosUsedFor: 'Podczas ćwiczenia ARCOS jest używany do reprezentowania typowych procesów takich jak:',
    arcosUsedForItem1: 'składanie i zarządzanie wnioskami o pomoc,',
    arcosUsedForItem2: 'koordynowanie i odpowiadanie na oferty wsparcia od innych narodów,',
    arcosUsedForItem3: 'śledzenie statusu i postępu wniosków,',
    arcosUsedForItem4: 'i reprezentacja uproszczonych przepływów transportu lub ewakuacji.',
    arcosDesc3: 'Przepływy pracy w ARCOS są celowo uproszczone i dostosowane do konkretnych celów szkoleniowych ćwiczenia.',
    arcosDesc4: 'Celem ARCOS nie jest symulowanie doskonałego lub kompletnego systemu rzeczywistego.',
    arcosDesc5: 'Jeśli pewne elementy różnią się od znanych procedur, jest to oczekiwane.',
    facilitatedBy: 'Wspierany przez MMCC-E',
    dhcInitiative: 'Digital Health Corner (DHC) jest wspólną inicjatywą:',
    dhcAuthor1: 'Sven Giegerich — Niemieckie Siły Zbrojne',
    dhcAuthor2: 'Mohamad Haji — Belgijska Obrona',
    dhcConviction: 'Zrodzona z przekonania, że innowacja kwitnie tam, gdzie pasja spotyka pragmatyzm.',
    dhcInspired: 'Zainspirowani przez MMCC-E, postanowiliśmy tworzyć proste, ale skuteczne rozwiązania.',
    dhcLove: 'Robimy to, bo kochamy naszą pracę i wierzymy, że cyfrowe pomysły mogą przekształcić współpracę w wojskowej opiece zdrowotnej.',
    dhcOpen: 'DHC jest otwartą platformą: wolną od hierarchii, otwartą na pomysły, napędzaną ciekawością.',
    dhcClosing: 'Digital Health Corner – gdzie ciekawość spotyka współpracę.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentacja',
    gettingStarted: 'Pierwsze kroki',
    userGuide: 'Podręcznik użytkownika',
    faq: 'Najczęściej zadawane pytania',
    troubleshooting: 'Rozwiązywanie problemów',
    apiReference: 'Dokumentacja API',
    downloadTemplate: 'Pobierz szablon',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Import pacjentów',
    uploadFile: 'Prześlij plik',
    selectFile: 'Wybierz plik',
    preview: 'Podgląd',
    importNow: 'Importuj teraz',
    importing: 'Importowanie...',
    importSuccess: '{{count}} pacjentów zaimportowano pomyślnie',
    importFailed: 'Import nie powiódł się',
    downloadTemplate: 'Pobierz szablon',
    dragDrop: 'Przeciągnij i upuść plik tutaj lub kliknij, aby wybrać',
    supportedFormats: 'Obsługiwane formaty: XLSX, XLS, CSV',
    rowsFound: '{{count}} wierszy znaleziono',
    validRows: '{{count}} prawidłowych wierszy',
    invalidRows: '{{count}} nieprawidłowych wierszy',
    duplicateRows: '{{count}} zduplikowanych wierszy',
    previewData: 'Podgląd danych',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Planowanie transportu',
    planRoute: 'Zaplanuj trasę',
    routeBuilder: 'Kreator trasy',
    addWaypoint: 'Dodaj punkt pośredni',
    removeWaypoint: 'Usuń punkt pośredni',
    estimatedDuration: 'Szacowany czas trwania',
    distance: 'Odległość',
    selectVehicle: 'Wybierz pojazd',
  },

  transportBooking: {
    title: 'Rezerwacja transportu',
    bookTransport: 'Zarezerwuj transport',
    availableSlots: 'Dostępne miejsca',
    bookingConfirmed: 'Rezerwacja potwierdzona',
    cancelBooking: 'Anuluj rezerwację',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Planowanie pojemności',
    totalCapacity: 'Całkowita pojemność',
    usedCapacity: 'Wykorzystana pojemność',
    availableCapacity: 'Dostępna pojemność',
    utilizationRate: 'Wskaźnik wykorzystania',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Szablony zasobów',
    dayTemplates: 'Szablony dnia',
    createTemplate: 'Utwórz szablon',
    editTemplate: 'Edytuj szablon',
    deleteTemplate: 'Usuń szablon',
    templateName: 'Nazwa szablonu',
    applyTemplate: 'Zastosuj szablon',
    noTemplates: 'Nie znaleziono szablonów',
    confirmDelete: 'Czy na pewno chcesz usunąć ten szablon?',
    confirmApply: 'Czy na pewno chcesz zastosować ten szablon? Nadpisze to istniejące dane.',
    exportTemplates: 'Eksportuj szablony',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Pasek ogłoszeń',
    createAnnouncement: 'Utwórz ogłoszenie',
    editAnnouncement: 'Edytuj ogłoszenie',
    deleteAnnouncement: 'Usuń ogłoszenie',
    message: 'Wiadomość',
    startTime: 'Czas rozpoczęcia',
    endTime: 'Czas zakończenia',
    active: 'Aktywne',
    noAnnouncements: 'Brak ogłoszeń',
    confirmDelete: 'Czy na pewno chcesz usunąć to ogłoszenie?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Szukaj...',
      noResults: 'Nie znaleziono wyników',
      showing: 'Wyświetlanie od {{from}} do {{to}} z {{total}}',
      rowsPerPage: 'Wierszy na stronę',
      previousPage: 'Poprzednia strona',
      nextPage: 'Następna strona',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Potwierdź',
      cancel: 'Anuluj',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Niezapisane zmiany',
      message: 'Masz niezapisane zmiany. Czy na pewno chcesz opuścić tę stronę?',
      stay: 'Pozostań na stronie',
      leave: 'Opuść stronę',
    },
    // EmptyState
    emptyState: {
      noData: 'Brak dostępnych danych',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Coś poszło nie tak',
      message: 'Wystąpił nieoczekiwany błąd. Proszę spróbować odświeżyć stronę.',
      retry: 'Ponów',
    },
    // ExportButton
    exportButton: {
      export: 'Eksportuj',
      exporting: 'Eksportowanie...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Drukuj',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Szkic',
      review: 'Przegląd',
      published: 'Opublikowane',
      selection: 'Selekcja',
      inTransit: 'W transporcie',
      completed: 'Zakończone',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Instancja online',
      message: 'Tryb tylko do odczytu. Dane są synchronizowane z serwera głównego.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Przeglądasz jako',
      loggedInAs: 'zalogowany jako {{nation}}',
      returnTo: 'Powrót do {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Szukaj stron, wniosków, transportów...',
      searching: 'Wyszukiwanie...',
      noResults: 'Brak wyników dla "{{query}}"',
      navigate: 'Nawiguj',
      select: 'Wybierz',
      close: 'Zamknij',
      pages: {
        dashboard: 'Pulpit',
        requests: 'Wnioski',
        transports: 'Transporty',
        map: 'Mapa',
        myPatients: 'Moi pacjenci',
        flowDiagram: 'Diagram przepływu',
        statistics: 'Statystyki',
        assets: 'Zasoby',
        startPoints: 'Punkty startowe / Węzły',
        treatmentFacilities: 'Placówki lecznicze',
        users: 'Użytkownicy',
        settings: 'Ustawienia',
        auditLogs: 'Dzienniki audytu',
        exerciseControl: 'Kontrola ćwiczenia',
        dataSync: 'Synchronizacja danych',
        patientImport: 'Import pacjentów',
        notifications: 'Powiadomienia',
        documentation: 'Dokumentacja',
      },
      actions: {
        importPatientsJson: 'Importuj Pacjentów (JSON)',
        importPatientsExcel: 'Importuj Pacjentów (Excel)',
        importUsers: 'Importuj Użytkowników (Excel)',
        importAssetTemplates: 'Importuj Szablony Zasobów (Excel)',
        importDayTemplates: 'Importuj Wpisy Szablonu Dnia (Excel)',
        exportRequests: 'Eksportuj Żądań (Excel)',
        exportPatients: 'Eksportuj Pacjentów (Excel)',
        exportUsers: 'Eksportuj Użytkowników (Excel)',
        exportCredentials: 'Eksportuj Poświadczenia (PDF)',
        exportAuditExcel: 'Eksportuj Dziennik audytu (Excel)',
        exportAuditPdf: 'Eksportuj Dziennik audytu (PDF)',
        pagePatientImport: 'Strona importu pacjentów',
        pageRequestDetail: 'Strona szczegółów żądania',
        pageUsers: 'Strona zarządzania użytkownikami',
        pageAssetTemplates: 'Strona szablonów zasobów',
        pageDayTemplates: 'Strona szablonów dnia',
        pageRequests: 'Strona listy żądań',
        pageAuditLogs: 'Strona dziennika audytu',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sesja wygasa',
      message: 'Twoja sesja wygaśnie za <strong>{{time}}</strong>. Proszę zapisać swoją pracę i zalogować się ponownie, aby kontynuować.',
      dismiss: 'Odrzuć',
      logoutNow: 'Wyloguj teraz',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Wybierz 4 strefy czasowe',
      configure: 'Skonfiguruj strefy czasowe',
      reset: 'Resetuj',
      apply: 'Zastosuj',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Wybierz lokalizację',
      latitude: 'Szerokość geograficzna',
      longitude: 'Długość geograficzna',
      clickToSelect: 'Kliknij na mapę, aby wybrać lokalizację',
    },
    // Modal
    modal: {
      close: 'Zamknij',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Strona główna',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Konserwacja systemu',
    message: 'System jest resetowany na kolejny dzień ćwiczenia. Proszę poczekać do zakończenia procesu.',
    autoRefresh: 'Ta strona zostanie automatycznie odświeżona, gdy system będzie ponownie dostępny.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Co najmniej 10 znaków',
    uppercase: '1 wielka litera',
    lowercase: '1 mała litera',
    digit: '1 cyfra',
    special: '1 znak specjalny',
  },
};

export default pl;
